module.exports = __webpack_public_path__ + "static/media/transfer-in-sme.a6b653e4.svg";